













































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import moment from 'moment';
import SearchRequirement from '@/components/searchRequirement.vue';
import { IOption, rewardTypeOptions, usageTimesOptions, saveTimeOptions, affectDepCountOptions, peopleCountOptions} from './optionConfig';
import { disabledDate } from '@/utils/other';

type IRewardModule = IPayment.IRewardModule;
type ISaveTimeModule = IPayment.ISaveTimeModule;
type IManDayModule = IPayment.IManDayModule;
type IRequirementModule = IPayment.IRequirementModule;

@Component({
  components: {
    SearchRequirement,
  },
})
export default class ContentForm extends Vue {
  @Prop({required: true}) private content!: IPayment.IContentData;
  private disabledDate = disabledDate;
  private rewardModule: IRewardModule = {
    rewardType: '',
    rewardContent: '',
  };
  private saveTimeModule: ISaveTimeModule = {
    usageTimes: '',
    saveTime: '',
    affectDepcount: '',
    peopleCount: '',
    calcContent: '',
    remarks: '',
  };
  private manDayModule: IManDayModule = {
    manDay: 0,
  };
  private requirementModule: IRequirementModule = {
    project: '',
    name: '',
    description: '',
    num: '',
    manDayStatus: '',
    follower: '',
    due: null,
  };
  private rewardTypeOptions: IOption[] = rewardTypeOptions;
  private usageTimesOptions: IOption[] = usageTimesOptions;
  private saveTimeOptions: IOption[] = saveTimeOptions;
  private affectDepCountOptions: IOption[] = affectDepCountOptions;
  private peopleCountOptions: IOption[] = peopleCountOptions;
  public updateContent() {
    const data: IPayment.IContentData = {
      rewardModule: this.rewardModule,
      saveTimeModule: this.saveTimeModule,
      manDayModule: this.manDayModule,
      requirementModule: this.requirementModule,
    };
    data.id = this.content.id;
    this.$emit('update:content', data);
  }
  private created() {
    this.initFormData();
  }
  private initFormData() {
    if (this.content.rewardModule) {
      this.rewardModule = {...this.content.rewardModule};
    }
    if (this.content.saveTimeModule) {
      this.saveTimeModule = {...this.content.saveTimeModule};
    }
    if (this.content.manDayModule) {
      this.manDayModule = {...this.content.manDayModule};
    }
    if (this.content.requirementModule) {
      this.requirementModule = {...this.content.requirementModule};
      const due = this.content.requirementModule.due;
      this.requirementModule.due = due ? moment(due) : null;
    }
  }
  private handleReqChange(requirementInfo: IRequirement.IResponse.IRequirementInfo | null) {
    if (requirementInfo) {
      this.requirementModule.num = '#' + requirementInfo.index;
      this.requirementModule.name = requirementInfo.title;
      this.requirementModule.project = requirementInfo.projectName;
    } else {
      this.requirementModule.num = '';
      this.requirementModule.project = '';
      this.requirementModule.name = '';
    }
  }
}
